import { useStoreActions, useStoreState } from '@discover-data/stores/restaurant/hooks';
import usePage from '@discover-data/stores/hooks/page/usePage';
import Logger from '@/lib/logger';
import { useAnalytics } from '@/components/analytics/hooks/useAnalytics';
import useDiscountOnlyQueryState from './useQueryState';

const logger = new Logger('useDiscountOnly');
// logger.enable();

// this won't work because the store value could be different to the hook value
function useValue() {
  const storeValue = useStoreState((state) => state.discountOnly.value);
  logger.log('storeValue', storeValue);

  if (storeValue !== null) {
    return storeValue;
  }

  return false;
}

export default function useDiscountOnly(): [
  boolean,
  (newDiscountOnly: boolean, trackEvent?: boolean) => Promise<void>,
] {
  const storeMode = useStoreState((state) => state.mode);
  const value = useValue();
  const { resetPage } = usePage();

  // set
  const setStoreValue = useStoreActions((actions) => actions.discountOnly.set);
  const [, setRouterValue] = useDiscountOnlyQueryState();
  const { track } = useAnalytics();

  async function set(newDiscountOnly: boolean, trackEvent = true) {
    logger.log('set', newDiscountOnly);
    resetPage();

    setStoreValue(newDiscountOnly);

    if (trackEvent) {
      track('button_clicked', {
        button_name: '50% off toggle',
        button_type: 'toggle',
        button_copy: '50% off',
        button_value: newDiscountOnly,
      });
    }

    await setRouterValue(newDiscountOnly);
  }

  return [value, set];
}
